<template>
  <div>
    <picture>
      <source :srcset="max" media="(min-width: 768px)" />
      <img :srcset="min" alt="" />
    </picture>
    <picture>
      <source class="hover" :srcset="hoverMax" media="(min-width: 768px)" />
      <img class="hover" :srcset="hoverMin" alt="" />
    </picture>
  </div>
</template>

<script>
export default {
  props: ['min', 'max', 'hoverMin', 'hoverMax'],
  data() {},
};
</script>
